---
meta:
  - title: Practicar con un examen - IUSPRO Docs
  - description: Aprende a completar un examen de práctica y ver los resultados.
---

# Practicar con un examen

Una vez que tiene un examen generado (ya sea creado por usted o compartido con usted), puede tomarlo para practicar.

## Comenzar el examen

Desde la página de detalle del examen, haga clic en **Comenzar**. Antes de iniciar puede configurar:

- **Sin límite de tiempo** — Responda a su propio ritmo
- **30 minutos**
- **60 minutos**
- **90 minutos**

Si elige un límite de tiempo, verá un cronómetro en la parte superior de la pantalla. Cuando queden menos de 5 minutos, el cronómetro cambiará a color rojo como alerta.

## Respondiendo preguntas

Las preguntas se muestran de dos en dos por página para que tenga espacio suficiente para leer y pensar.

Para cada pregunta:

1. **Lea la pregunta** y las opciones de respuesta (A, B, C, D)
2. **Seleccione una opción** haciendo clic en ella — su respuesta se guarda automáticamente
3. **Navegue** con los botones "Anterior" y "Siguiente" para moverse entre preguntas

### Barra de progreso

En la parte superior verá una barra de progreso segmentada que muestra:

- **Azul**: La pregunta actual
- **Verde**: Pregunta respondida correctamente (si ya reveló la respuesta)
- **Rojo**: Pregunta respondida incorrectamente (si ya reveló la respuesta)
- **Gris claro**: Pregunta sin responder

Puede hacer clic en cualquier segmento para saltar directamente a esa pregunta.

## Revelar respuestas

Para cualquier pregunta puede hacer clic en **Ver respuesta**. Al hacerlo:

- Se muestra cuál es la **respuesta correcta** (resaltada en verde)
- Si su selección fue incorrecta, se marca en rojo
- Se despliega una **explicación detallada** de por qué esa es la respuesta correcta
- Se muestra la **cita directa** de la ley o fuente legal que la respalda

**Importante:**

- Debe seleccionar una opción antes de poder revelar la respuesta
- Una vez revelada, **no puede cambiar su respuesta** para esa pregunta
- Si no ha seleccionado una opción y revela la respuesta, esa pregunta quedará sin responder

## Finalizar el examen

Cuando esté listo, haga clic en **Finalizar**. Antes de confirmar verá un resumen con:

- Cuántas preguntas ha respondido
- Cuántas quedan sin responder
- Un aviso de que las respuestas no verificadas serán evaluadas automáticamente

Puede elegir **Seguir respondiendo** para volver al examen, o **Finalizar** para terminar y ver su puntuación.

## Resultados

Al finalizar verá la pantalla de resultados con:

### Puntuación general

- Un indicador circular con su **porcentaje de aciertos**
- La cantidad de respuestas correctas sobre el total (por ejemplo, 17/20)
- Una calificación:
  - **Aprobado** (70% o más)
  - **Parcial** (entre 50% y 69%)
  - **No aprobado** (menos del 50%)

### Desglose

- **Correctas** — Cantidad de respuestas acertadas
- **Incorrectas** — Cantidad de respuestas equivocadas
- **Sin responder** — Preguntas que dejó en blanco

### Revisión de preguntas

Debajo del resumen puede revisar cada pregunta individualmente. Para cada una verá:

- La pregunta completa con todas las opciones
- Su respuesta y la respuesta correcta
- La explicación y la cita legal

## Re-tomar un examen

Si quiere volver a intentarlo, puede hacer clic en **Re-tomar examen**. Esto crea un nuevo intento con las mismas preguntas pero sin sus respuestas anteriores. El historial de intentos previos se conserva y puede consultarlos desde la página de resultados.
